import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * @typedef {Object} ProductWeightRefs
 * @property {HTMLElement} weightContainer
 * @property {HTMLElement} weight
 */

/**
 * A custom element that displays the selected variant's weight.
 *
 * @extends {Component<ProductWeightRefs>}
 */
class ProductWeightComponent extends Component {
  requiredRefs = ['weightContainer', 'weight'];

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateWeight);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateWeight);
  }

  /**
   * Updates the variant weight.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateWeight = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    if (event.detail.resource) {
      const variantWeight = Number(event.detail.resource.weight || 0);
      const formattedWeight = event.detail.resource.formatted_weight || '';

      if (variantWeight > 0 && formattedWeight) {
        this.style.display = 'block';
        this.refs.weight.textContent = formattedWeight;
      } else {
        this.style.display = 'none';
        this.refs.weight.textContent = '';
      }
    }
  };
}

if (!customElements.get('product-weight-component')) {
  customElements.define('product-weight-component', ProductWeightComponent);
}
